// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
// 缓存
import util from './common/util'
import storage from './common/storage'

// 有赞样式
import Vant from 'vant'
import 'vant/lib/index.css'
//公共样式
import '@/assets/css/base.css'
import '@/assets/css/icon/iconfont.css'
import '@/assets/css/store.css'  //门店样式

//引入封装好api接口
import api from './request/api'
Vue.prototype.api = api.requestApi //使用方法为:this.api.接口定义名（定义名见api.js）

//引入封装好axios
import request from './request/http'
import qs from 'qs'
Vue.prototype.axios = request    //全局注册，使用方法为:this.$axios
Vue.prototype.qs = qs;


Vue.use(Vant);
Vue.config.productionTip = false;

import wxJSSDK from './common/wx-js-sdk'
const wxApi = {
    wxShare: wxJSSDK.creatWxShare, // 微信分享
    wxPay: wxJSSDK.creatWxPay, // 微信支付
    wxScan: wxJSSDK.scanQRCode, // 微信扫一扫
    wxgetlocation: wxJSSDK.getlocation // 微信地址
}
Vue.prototype.wx = wxApi

Vue.config.productionTip = false;
Vue.use(Vant);

// "/h5/index.html" 重定向线上路径  ---  "/" 本地路径
//var redirect_url = api.requestApi.wxapp.index == 'wxapp' ? "/h5/index.html" : "/"
var redirect_url =  "/"

// 获取url指定参数
const parseUrl = function (query = location.href) {
    if (typeof query != "string") {
        console.warn("params must be a url string");
        return {};
    }
    let match;
    let urlParams = {};
    // const pl = /\+/g;
    const search = /([^&=]+)=?([^&]*)/g;
    const queryStr = query.indexOf("?") > -1 ? query.split("?")[1] : query;

    while ((match = search.exec(queryStr))) {
        urlParams[match[1]] = match[2];
    }
    return urlParams;
}


/* 获取用户信息 */
Vue.prototype.getUserInfo = function(callback){
    if (util.getCookie('token')) {
        var user_info = storage.s_getItem('useinfo')
        if (!user_info) {
            request({
                url: api.requestApi.member.get_member
            })
            .then((res) => {
                if (res.error === 0) {
                    res.member.search = res.search
                    storage.s_setItem('useinfo',res.member)
                    callback&&callback(res.member)
                }
            })
        }else {
            callback&&callback(user_info)
        }
    } else {

        router.push('/author')
    }
}


router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }

    if (to.path == '/author' && util.getCookie('token')) {
        // 用户使用后退返回到授权页，则默认回到首页
        next('/index')
        return false
    }

    if (to.path == '/register' && storage.s_getItem('useinfo').mobile) {
        // 已注册跳转首页
        next('/mycenter')
        return false
    }
    /*
    * 判断sessionStorage里有没有token
    * 并且是否是微信授权页
    */

    if (parseUrl().token && !util.getCookie('token')) {
        var token = parseUrl().token;
        //storage.s_setItem('token', token)
        util.setCookie('token', token, 1)
        window.history.replaceState('', '', redirect_url) // 截取url，去掉token
        var url = storage.s_getItem('beforeLoginUrl') ? storage.s_getItem('beforeLoginUrl') : '/index'
        next(url)
    } else if (!util.getCookie('token') && to.path != '/author') {
        storage.s_setItem('beforeLoginUrl', to.fullPath) // 保存用户进入的url
        next('/author') // 进入到微信授权页
        return false
    } else {
        if (parseUrl().token) window.history.replaceState('', '', redirect_url) // 截取url，去掉token
        next();
    }
})





/* eslint-disable no-new */
new Vue({
  el: '#App',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js